<div [formGroup]="form">
  <div class="table-responsive no-min-height">
    <table
      class="table table_middle table-striped"
      [formArrayName]="field_name">
      <tr>
        <th>Основное</th>
        <th>Шоссе</th>
        <th></th>
      </tr>
      @for (el of highways.controls; track el; let i = $index) {
        <tr
          [formGroupName]="i">
          <td>
            <app-material-input-checkbox
              [disabled]="highways.controls[i].get('is_main').value || !isEdit"
              formControlName="is_main">
            </app-material-input-checkbox>
          </td>
          <td style="min-width: 15rem;">
            @if (highway_list && highway_list.length && isEdit) {
              <app-material-select2
                formControlName="id">
                <option [value]="''">Не выбрано</option>
                @for (el of highway_list | exclude: chosen_elements:el.get('id').value; track el) {
                  <option
                    [value]="el['dict_highway_id']">
                    {{el['dict_highway_caption']}}
                  </option>
                }
              </app-material-select2>
            }
            @if (highway_list && highway_list.length && !isEdit) {
              @let currentId = highways.controls[i].get('id').value;
              @if (currentId) {
                <p>
                  @for (item of highway_list; track item.dict_highway_id) {
                    @if (item['dict_highway_id'] === +currentId) {
                      {{ item['dict_highway_caption'] }}
                    }
                  }
                </p>
              } @else {
                <p>Не выбрано</p>
              }
            }
          </td>
          <td>
            @if (isEdit) {
              <a
                (click)="dropHighway(i)"
                class="button button_icon ng-star-inserted"
                href="javascript:void(0)"
                title="Информация">
                <i class="fa fa-fw fa-trash"></i>
              </a>
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>
@if (isEdit) {
  <span class="button mt-3" (click)="addHighway()">Добавить</span>
}
